module.exports = __webpack_public_path__ + "static/media/08_Maf_NuestroEquipo_EmmanuelMartinez.da802f75.jpg";